import React from 'react';
import './DeliveryReceipt.scss';
import logo from '../../../images/nukrim.png';

const DeliveryReceipt = ({ deservants, recordsPerPage }) => {
    return (
        <div className="print-container">
            {deservants.map((item, index) => {
                // Handle both flat deservant objects and nested cycle-deservant objects
                const deservant = item.deservantId || item;
                const user = deservant.userId || {};
                const distributor = item.distributorId || deservant.distributor || {};
                const distUser = distributor.userId || {};

                return (
                    <div 
                        key={item.id} 
                        className={`receipt-card per-page-${recordsPerPage}`}
                    >
                        <div className="receipt-header">
                            <img src={logo} alt="Logo" className="receipt-logo" />
                            <div className="header-text">
                                <h3>RASHAN DISTRIBUTION SYSTEM</h3>
                                <p>Delivery Acknowledgement Receipt</p>
                            </div>
                            <div className="receipt-no">
                                No: <strong>#{deservant.id}</strong>
                            </div>
                        </div>

                        <div className="receipt-body">
                            <div className="info-grid">
                                <div className="info-item">
                                    <label>Deservant Name:</label>
                                    <span>{user.name}</span>
                                </div>
                                <div className="info-item">
                                    <label>Mobile:</label>
                                    <span>{user.mobile}</span>
                                </div>
                                <div className="info-item">
                                    <label>CNIC:</label>
                                    <span>{user.cnic}</span>
                                </div>
                                <div className="info-item">
                                    <label>Address:</label>
                                    <span className="address-text">{user.address}</span>
                                </div>
                            </div>

                            <div className="distributor-info">
                                <div className="info-item">
                                    <label>Distributor:</label>
                                    <span>{distUser.name || 'N/A'}</span>
                                </div>
                                <div className="info-item">
                                    <label>Location:</label>
                                    <span>{user.location?.locationName || user.location || 'N/A'}</span>
                                </div>
                            </div>

                        <div className="items-section">
                            <table className="items-table">
                                <thead>
                                    <tr>
                                        <th>Description</th>
                                        <th>Quantity</th>
                                        <th>Received (Sign)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Rashan Package (Monthly)</td>
                                        <td>1 Unit</td>
                                        <td>________________</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="receipt-footer">
                        <div className="footer-signatures">
                            <div className="sig-box">
                                <div className="sig-line"></div>
                                <span>Distributor Signature</span>
                            </div>
                            <div className="sig-box">
                                <div className="sig-line"></div>
                                <span>Authorized Signature</span>
                            </div>
                        </div>
                        <div className="timestamp">
                            Printed on: {new Date().toLocaleString()}
                        </div>
                    </div>
                </div>
                );
            })}
        </div>
    );
};

export default DeliveryReceipt;
